export default function Modal(props) {
  return (
    <div className="modal fade show" tabIndex="-1" role="dialog" aria-hidden="true" style={{ display: "block" }}>
      <div className={`modal-dialog modal-dialog-scrollable modal-dialog-centered ${props.size ?? ""}`} role="document">
        <div className="modal-content border-0">{props.children}</div>
      </div>
    </div>
  );
}
